<ahs-splash style="--splash-background: #fff" [value]="appClientLogoImg">
	<div fxLayout="column" fxLayoutAlign="center center" #splashLogo>
		<div fxLayout="column" fxLayoutAlign="center center">
			<ion-spinner name="lines" style="width: 64px; height: 64px"></ion-spinner>
			<img id="clientLogoImg" class="splash-logo" src="{{ appClientLogoImg }}" alt="" />
		</div>
	</div>
</ahs-splash>

<ion-app>
	<a
		id="skip-to-main-link"
		class="skip-to-main-link"
		href="#main-content"
		(click)="skipToMain($event)"
		(keydown.space)="skipToMain($event)"
		aria-label="Skip to main content"
	>
		Skip to main content
	</a>
	<div *ngIf="isLive">
		<ion-split-pane contentId="main-content">
			<ion-menu contentId="main-content" type="overlay">
				<ion-content>
					<ion-header class="bar-profile" style="box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.14)">
						<ion-toolbar>
							<ion-title>
								<!--Only show Client Logo-->
								<app-branding-header></app-branding-header>
							</ion-title>
						</ion-toolbar>
					</ion-header>

					<ion-list
						tabindex="0"
						aria-label="Application Feature List"
						#menuitemlist
						(window:keydown.ArrowRIght)="rightOnMenuItemList($event)"
					>
						<ion-menu-toggle auto-hide="false" *ngFor="let p of appPages">
							<div *ngIf="p.isEnabled !== false">
								<ion-item
									#menuItem
									class="pointer"
									style="padding-left: 0px"
									routerDirection="root"
									[routerLink]="[p.url]"
									[state]="p?.stateData ? p?.stateData : null"
									[routerLinkActive]="'route-is-active'"
									lines="full"
									(keyup.enter)="focusOnRouterOutlet()"
								>
									<fa-layers style="margin-right: 15px" [fixedWidth]="true" size="lg">
										<!--If color attribute in client config containts a hex color, it will override the menu-icon class. Leave this empty to use defaults-->
										<fa-icon
											class="menu-icon"
											[ngStyle]="{ color: p.color ? p.color : '' }"
											[icon]="p.icon"
										>
										</fa-icon>
										<fa-layers-counter
											*ngIf="p.mobileShowOverlay && p.layerCount"
											[classes]="['fa-custom-counter']"
											content="{{ p.layerCount }}"
										>
										</fa-layers-counter>
									</fa-layers>
									<ion-label [style.font-weight]="p.fontWeight">
										{{ p.title }}
									</ion-label>
									<span *ngIf="p.altIcon">
										<fa-icon
											[ngClass]="p.altIconColor ? p.altIconColor : p.color"
											[icon]="p.altIcon"
											size="lg"
											[fixedWidth]="true"
											pull="right"
										></fa-icon>
									</span>
								</ion-item>
							</div>
						</ion-menu-toggle>
					</ion-list>
				</ion-content>
				<!--Only show Env Details for non production-->
				<environment-details *ngIf="!isProd" class="app-env-details"></environment-details>
			</ion-menu>
			<ion-router-outlet
				id="main-content"
				role="main"
				tabindex="0"
				(window:keydown.ArrowLeft)="leftOnRouterOutlet($event)"
			>
			</ion-router-outlet>
		</ion-split-pane>
		<ion-fab vertical="center" horizontal="end" slot="fixed">
			<ion-fab-button (click)="mobileChatButton()" *ngIf="showChatFab && isDBReady">
				<ion-icon name="chatbubbles-outline"></ion-icon>
			</ion-fab-button>
		</ion-fab>
		<ahs-tutorial *ngIf="initComplete"></ahs-tutorial>
		<ahs-intro *ngIf="initComplete"></ahs-intro>
	</div>
	<div *ngIf="!isLive">
		<ahs-maintenance></ahs-maintenance>
	</div>
</ion-app>
